import { Injectable } from '@angular/core';
import {
    DATIQ_MC_PANEL_INFO_MESSAGE_3DZ_FORECAST,
    DATIQ_MC_PANEL_INFO_MESSAGE_3DZ_INBOUND,
    DATIQ_MC_PANEL_INFO_MESSAGE_3DZ_LOAD_TRUCK,
    DATIQ_MC_PANEL_INFO_MESSAGE_FORECAST_UPDATING,
    DATIQ_MC_PANEL_INFO_MESSAGE_INBOUND_UPDATING,
    DATIQ_MC_PANEL_INFO_MESSAGE_SELECT_AREA,
    DATIQ_MC_PANEL_INFO_MESSAGE_SHOWING_LOAD_TO_TRUCK,
} from '@dat/datiq-mc/utils';
import {
    Directions,
    GeoTypes,
    IIqMcInfoBadge,
    McQuery,
    TimeFrames,
    emptyIqMcInfoBadge,
} from '../models';

@Injectable({
    providedIn: 'root',
})
export class IqMcInfoBadgeMapperService {
    constructor() {}

    mapMciInfoBadgeSettings(params: McQuery): IIqMcInfoBadge {
        const message: string =
            params?.direction === Directions.InBound
                ? this.mapMciInboundMessage(params)
                : this.mapMciOutboundMessage(params);
        return { ...emptyIqMcInfoBadge, message };
    }

    mapMciOutboundMessage(params: McQuery): string {
        return params?.timeframe === TimeFrames.EightDayForecast
            ? this.mapMciOutboundForecastMessage(params)
            : params?.timeframe === TimeFrames.Current
            ? this.mapMciOutboundCurrentMessage(params)
            : this.mapMciMessageOutboundGeoCode(params);
    }

    mapMciOutboundCurrentMessage(params: McQuery): string {
        return params?.geoType === GeoTypes.ThreeDZ
            ? this.mapMciOutboundCurrentMessage3DZ(params)
            : this.mapMciMessageOutboundGeoCode(params);
    }

    mapMciMessageOutboundGeoCode(params: McQuery): string {
        return !!params?.geoCode || !!params?.displayName
            ? DATIQ_MC_PANEL_INFO_MESSAGE_SHOWING_LOAD_TO_TRUCK
            : DATIQ_MC_PANEL_INFO_MESSAGE_SELECT_AREA;
    }
    mapMciOutboundCurrentMessage3DZ(params: McQuery): string {
        return !!params?.geoCode || !!params?.displayName
            ? DATIQ_MC_PANEL_INFO_MESSAGE_3DZ_LOAD_TRUCK
            : DATIQ_MC_PANEL_INFO_MESSAGE_SELECT_AREA;
    }

    mapMciOutboundForecastMessage(params: McQuery): string {
        return params?.geoType === GeoTypes.ThreeDZ
            ? DATIQ_MC_PANEL_INFO_MESSAGE_3DZ_FORECAST
            : DATIQ_MC_PANEL_INFO_MESSAGE_FORECAST_UPDATING;
    }

    mapMciInboundMessage(params: McQuery): string {
        return params?.timeframe === TimeFrames.EightDayForecast
            ? this.mapMciInboundForecastMessage(params)
            : params?.timeframe === TimeFrames.Current
            ? this.mapMciInboundCurrentMessage(params)
            : DATIQ_MC_PANEL_INFO_MESSAGE_INBOUND_UPDATING;
    }

    mapMciInboundCurrentMessage(params: McQuery): string {
        return params?.geoType === GeoTypes.ThreeDZ
            ? DATIQ_MC_PANEL_INFO_MESSAGE_3DZ_INBOUND
            : DATIQ_MC_PANEL_INFO_MESSAGE_INBOUND_UPDATING;
    }

    mapMciInboundForecastMessage(params: McQuery): string {
        return params?.geoType === GeoTypes.ThreeDZ
            ? DATIQ_MC_PANEL_INFO_MESSAGE_3DZ_FORECAST
            : DATIQ_MC_PANEL_INFO_MESSAGE_FORECAST_UPDATING;
    }
}
